import { render } from "./VabThemeDrawer.vue?vue&type=template&id=5f7147d2"
import script from "./VabThemeDrawer.vue?vue&type=script&lang=js"
export * from "./VabThemeDrawer.vue?vue&type=script&lang=js"

import "./VabThemeDrawer.vue?vue&type=style&index=0&id=5f7147d2&lang=scss"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabTheme/components/VabThemeDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f7147d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f7147d2', __exports__)) {
    api.reload('5f7147d2', __exports__)
  }
  
  module.hot.accept("./VabThemeDrawer.vue?vue&type=template&id=5f7147d2", () => {
    api.rerender('5f7147d2', render)
  })

}


export default __exports__